const ENDPOINT = 'UPDATEalbumSongsOrder';
function updateAlbumSongsOrder(gateway, params = { albumid: '', neworder: [] }) {
    return gateway.get(updateAlbumSongsOrder.endpoint, params);
}
updateAlbumSongsOrder.endpoint = ENDPOINT;

export { updateAlbumSongsOrder as default };
//# sourceMappingURL=updateAlbumSongsOrder.js.map
